import {
  Box,
  Button,
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import React, { useEffect, useState } from "react";

import CryptoJS from "crypto-js";
import { confirmDeposit, getAllDeposits } from "../apis";
import toast from "react-hot-toast";
import { formatDateString } from "../helpers";

function DepositPage() {
  const [deposits, setDeposits] = useState([])

  const reject = async (depositId) => {

  }

  const confirm = async (depositId) => {
    try {
      const hashed = CryptoJS.HmacSHA256(
        JSON.stringify(depositId),
        process.env.REACT_APP_TOKEN
      ).toString(CryptoJS.enc.Hex);
      const data = await confirmDeposit(depositId, hashed)
      if (data) {
        fetchData()
        toast.success(data.message)
      }
    } catch (error) {

    }
  }

  const fetchData = async () => {
    const data = await getAllDeposits()
    setDeposits(data)
  }

  useEffect(() => {
    fetchData()
  }, [])

  return (
    <React.Fragment>
      <Container maxWidth="xl">
        <Box
          sx={{
            display: "flex",
            alignItems: "end",
            justifyContent: "center",
            paddingTop: "60px",
          }}
        >

          <TableContainer component={Paper} sx={{ backgroundColor: "#131313", }}>
            <Table
              sx={{ border: "none", backgroundColor: "#131313" }}
              aria-label="simple table"
            >
              <TableHead sx={{ backgroundColor: "#131313" }}>
                <TableRow>
                  <TableCell
                    sx={{
                      border: "none",
                      fontFamily: '"SF Mono", monospace',
                      color: "#fff",
                    }}
                  >
                    id
                  </TableCell>
                  <TableCell
                    sx={{
                      border: "none",
                      fontFamily: '"SF Mono", monospace',
                      color: "#fff",
                    }}
                    align="left"
                  >
                    balance
                  </TableCell>
                  <TableCell
                    sx={{
                      border: "none",
                      fontFamily: '"SF Mono", monospace',
                      color: "#fff",
                    }}
                    align="left"
                  >
                    user
                  </TableCell>
                  <TableCell
                    sx={{
                      border: "none",
                      fontFamily: '"SF Mono", monospace',
                      color: "#fff",
                    }}
                    align="left"
                  >
                    date
                  </TableCell>
                  <TableCell
                    sx={{
                      border: "none",
                      fontFamily: '"SF Mono", monospace',
                      color: "#fff",
                    }}
                    align="left"
                  >
                    asset
                  </TableCell>
                  <TableCell
                    sx={{
                      border: "none",
                      fontFamily: '"SF Mono", monospace',
                      color: "#fff",
                    }}
                    align="left"
                  >
                    status
                  </TableCell>
                  <TableCell
                    sx={{
                      border: "none",
                      fontFamily: '"SF Mono", monospace',
                      color: "#fff",
                    }}
                    align="left"
                  >
                    hash
                  </TableCell>
                  <TableCell
                    sx={{
                      border: "none",
                      fontFamily: '"SF Mono", monospace',
                      color: "#fff",
                    }}
                    align="left"
                  >
                    actions
                  </TableCell>

                </TableRow>
              </TableHead>
              <TableBody sx={{ backgroundColor: "#1B1B1B", border: "none" }}>
                {deposits?.map((item, key) => (
                  <TableRow
                    key={key}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell
                      component="th"
                      scope="row"
                      sx={{
                        fontFamily: '"SF Mono", monospace',
                        color: "#fff",
                        borderTopLeftRadius: "16px",
                        borderBottomLeftRadius: "16px",
                        padding: "13px",
                      }}
                    >
                      {item.deposit_id}
                    </TableCell>
                    <TableCell
                      sx={{
                        border: "none",
                        fontFamily: '"SF Mono", monospace',
                        padding: "13px",
                        color: "#fff",
                      }}
                      align="left"
                    >
                      {item.balance}
                    </TableCell>
                    <TableCell
                      sx={{
                        border: "none",
                        fontFamily: '"SF Mono", monospace',
                        padding: "13px",
                        color: "#fff",
                      }}
                      align="left"
                    >
                      {item.name}
                    </TableCell>
                    <TableCell
                      sx={{
                        border: "none",
                        fontFamily: '"SF Mono", monospace',
                        padding: "13px",
                        color: "#fff",
                      }}
                      align="left"
                    >
                      {formatDateString(item.created_at)}
                    </TableCell>
                    <TableCell
                      sx={{
                        border: "none",
                        fontFamily: '"SF Mono", monospace',
                        padding: "13px",
                        color: "#fff",
                      }}
                      align="left"
                    >
                      {item.symbol}
                    </TableCell>

                    <TableCell
                      sx={{
                        border: "none",
                        fontFamily: '"SF Mono", monospace',
                        padding: "13px",
                        color: "#fff",
                      }}
                      align="left"
                    >
                      {item.status}
                    </TableCell>

                    <TableCell
                      sx={{
                        border: "none",
                        fontFamily: '"SF Mono", monospace',
                        padding: "13px",
                        color: "#fff",
                      }}
                      align="left"
                    >
                      <a target="_blank" rel="noopener noreferrer" href={`https://snowtrace.io/tx/${item?.hash}`}>Hash</a>
                    </TableCell>

                    <TableCell
                      sx={{
                        border: "none",
                        fontFamily: '"SF Mono", monospace',
                        padding: "13px",
                        color: "#fff",
                        borderTopRightRadius: "16px",
                        borderBottomRightRadius: "16px",
                      }}
                      align="left"
                    >

                      <Button
                        sx={{
                          fontWeight: 600,
                          fontSize: 15,
                          color: "#fff",
                          backgroundColor: "#E63B1F",
                          borderRadius: "16px",
                          padding: "10px 27px",
                          textTransform: "none",
                          fontFamily: '"Inter", sans-serif',
                          "&::first-letter": {
                            textTransform: "capitalize",
                          },
                          "&:hover": {
                            background: "#E63B1F",
                          },
                        }}
                        onClick={() => reject(item.deposit_id)}
                      >
                        Reject
                      </Button>
                      <Button
                        sx={{
                          fontWeight: 600,
                          fontSize: 15,
                          color: "#fff",
                          backgroundColor: "#E63B1F",
                          borderRadius: "16px",
                          padding: "10px 21px",
                          textTransform: "none",
                          marginLeft: "8px",
                          marginRight: "10px",
                          fontFamily: '"Inter", sans-serif',
                          "&::first-letter": {
                            textTransform: "capitalize",
                          },
                          "&:hover": {
                            background: "#E63B1F",
                          },
                        }}
                        onClick={() => confirm(item.deposit_id)}
                      >
                        Confirm
                      </Button>
                    </TableCell>

                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Container>
    </React.Fragment>
  );
}

export default DepositPage;
